import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';
import { Chats } from '../interfaces/chatData';
import { MessagesService } from './messages.service';
import { SuscriptionService } from './suscription.service';
import { SuscriptionsWS } from '../interfaces/suscription.interface';


@Injectable({
    providedIn: 'root',
})
export class WebsocketService {

    private ulrStomp = environment.baseWebSocket;
    private topic = environment.baseTopic;
    private wsClient: any;
    private conectado: boolean = false;
    rolUsuario: any;
    idSuscription: any;
    idStatus: any;
    selectedChat: any

    constructor(private messageService: MessagesService, private suscriptionService: SuscriptionService){}

    connect(idSuscription: string, idCustomer: string, idUser: string) {
        const params = this.createParams(idSuscription,idCustomer,idUser)
        const ws = new SockJS(`${this.ulrStomp}${params}`);
        this.wsClient = Stomp.over(ws);
        const that = this;

        this.wsClient.connect({}, function () {
            that.conectado = true;
            that.wsClient.subscribe(`${that.topic}/conversaciones`, async (message: { body: any;
             }) => {
                const data: Chats[] = JSON.parse(message.body)
                that.messageService.setChats(data)
                const chatIdSelected = that.selectedChat?.chatId;
                const getMessages = await that.messageService.getMessages(chatIdSelected, that.idSuscription,0,20)
                that.messageService.setMessages(getMessages.data)
            });
            that.wsClient.subscribe(`${that.topic}/conversaciones-delete`, async (message: { body: any;
             }) => {
                const data: Chats[] = JSON.parse(message.body)
                 that.messageService.setChats(data)
                 const chatIdSelected = that.selectedChat?.chatId;
                 const getMessages = await that.messageService.getMessages(chatIdSelected, that.idSuscription,0,20)
                 that.messageService.setMessages(getMessages.data)
            });
            that.wsClient.subscribe(`${that.topic}/dispositivos`, async (message: { body: any;
            }) => {
               const data: SuscriptionsWS = JSON.parse(message.body);
               that.suscriptionService.establecerDispositivos(data);

           });
        });
    }

    connectDevice (idSuscription: string, idCustomer: string, idUser: string) {
        const params = `${this.createParams(idSuscription,idCustomer,idUser)}&device=0`;

        const ws = new SockJS(`${this.ulrStomp}${params}`);
        this.wsClient = Stomp.over(ws);
        const that = this;

        this.wsClient.connect({}, function () {
            that.conectado = true;
            that.wsClient.subscribe(`${that.topic}/dispositivo-conectado`, async (message: { body: any;}) => {
                const data: any = JSON.parse(message.body)
                that.suscriptionService.establecerConeccion(data);
            });
        });
    }

    disconnect() {
        if (this.conectado) {
            this.wsClient.disconnect();
        }
    }

    private createParams(idSuscription: string, idCustomer: string, idUser: string){
        return idUser == undefined || idUser === "" ? 
        `?idSuscription=${idSuscription}&idCustomer=${idCustomer}` :
        `?idSuscription=${idSuscription}&idUser=${idUser}&idCustomer=${idCustomer}`;
    }

    connectSync (idSuscription: string, idCustomer: string, idUser: string) {
        const params = this.createParams(idSuscription,idCustomer,idUser);

        const ws = new SockJS(`${this.ulrStomp}${params}`);
        this.wsClient = Stomp.over(ws);
        const that = this;

        this.wsClient.connect({}, function () {
            that.conectado = true;
            that.wsClient.subscribe(`${that.topic}/sincronizacion`, async (message: { body: any;}) => {
                console.log(message.body)
                that.suscriptionService.setTotalMessages(message.body)
            });
        });
    }

}
